import { groupNav } from "@repo/module-kit"

import { dashboardModules } from "@/modules"
import type { DashboardNavItem } from "@/modules/types"

export type NavItem = DashboardNavItem

export interface NavGroup {
  title: string
  items: NavItem[]
}

/** Groups appear in this order; a module may add a new group after them. */
const GROUP_ORDER = ["Overview", "Business", "Publishing", "System"]

export const navGroups: NavGroup[] = groupNav(
  dashboardModules.flatMap((module) => module.nav ?? []),
  GROUP_ORDER
)

export function isNavActive(pathname: string, to: string) {
  if (to === "/") return pathname === "/"
  return pathname === to || pathname.startsWith(`${to}/`)
}

export function findNavItem(pathname: string) {
  return navGroups
    .flatMap((group) => group.items)
    .find((candidate) => isNavActive(pathname, candidate.to))
}

/** Pages that belong to no module, so they are not in the sidebar but still need a name. */
const coreTitles: Record<string, string> = { "/profile": "Profile" }

export function findNavTitle(pathname: string) {
  return findNavItem(pathname)?.title ?? coreTitles[pathname] ?? "Dashboard"
}
